import { cn } from '@sohanemon/utils';
import { localizeDigits } from '@sohanscript/lib/utils/format';
import { useSohanEmon } from '#/lib/hooks/sohanemon.tsx';

type ResumeExperienceProps = React.ComponentProps<'div'>;

export function ResumeExperience({
	className,
	...props
}: ResumeExperienceProps) {
	const { experiences } = useSohanEmon();

	return (
		<div className={cn('divide-y divide-border', className)} {...props}>
			{experiences.map((exp) => (
				<section key={exp.id} className="py-5 first:pt-0">
					<div className="mb-2 flex items-start justify-between gap-4">
						<div>
							<h3
								className={cn(
									'font-bold text-foreground/95 text-sm tracking-tight',
								)}
							>
								{exp.role}
							</h3>
							<p className="mt-0.5 font-medium text-foreground text-xs">
								{exp.company}{' '}
								<span className="font-normal text-muted-foreground">
									· {exp.location}
								</span>
							</p>
						</div>
						<span className="mt-0.5 shrink-0 text-right font-mono text-3xs text-muted-foreground">
							{localizeDigits(exp.period)}
						</span>
					</div>
					<ul className="mt-2 space-y-1.5">
						{exp.deliverables.map((d) => (
							<li key={d.id} className="flex items-start gap-2">
								<span className="mt-1.5 h-1 w-1 shrink-0 rounded-full bg-primary" />
								<span className="text-muted-foreground text-xs leading-relaxed">
									{d.text}
								</span>
							</li>
						))}
					</ul>
				</section>
			))}
		</div>
	);
}
